
import countries from "./allCountries.json";
import countriesStates from "./allCountryStates.json";
import usAllStates from "./allUSStates.json";
import usAllCounty from "./allUSCounty.json";

const countryId = 6252001;
const ALLCOUNTRY = "allCountry";
const ALLUSSTATE = "allUSState";

export function getGeoStateData(geonameId) {
  const data = usAllStates.filter(x => x.countryGeonameId == geonameId);
  return data;
}

export async function getGeoCountyData(geonameId) {
  const data = usAllCounty.filter(x => x.stateGeonameId == geonameId);
  return data;
}

export async function getGeoCityData(geonameId) {
  const data = usAllCounty.filter(x => x.stateGeonameId == geonameId);
  return data;
}

export function getGeoData(geonameId) {
  const data = countriesStates.filter(x => x.countryGeonameId == geonameId);
  return data;
}

export function getStateList() {
  return getGeoData(countryId);
}

export function getAllCountries() {
  const countryJs = countries;//JSON.parse(countries);
  return countryJs;
}

export default {
  getGeoData,
  getStateList,
  getAllCountries,
};
